import React from "react";
import Warehouselistdata from "./Table/Warehouselistdata";
import { useNavigate } from "react-router-dom";

export default function WarehouseList() {
  const Navigate = useNavigate();

  return (
    <div>
      <div className="flex ">
        <div>
          <h2 className="font-Montserrat text-xl font-bold text-black">
            Warehouses
          </h2>
          <div className="border-b-2 border-blue-200 w-20"></div>
        </div>
        <div className="flex flex-wrap w-fit ml-auto">
          <button
            type="button"
            onClick={() => {
              Navigate("/dashboard/warehouse/warehouse-list/Add-warehouse");
            }}
            className="border-2 border-blue-200 hover:text-white text-base font-Montserrat font-bold text-blue-200 flex-shrink hover:border-blue-100 hover:bg-blue-100 place-content-center rounded-md px-2 py-1 flex flex-grow w-60 "
          >
            Add Warehouse
          </button>
        </div>
      </div>
      <div className="flex flex-wrap justify-center">
        <div
          className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
          // "w-[calc(100vw_-_12rem)]"
        >
          <Warehouselistdata />
        </div>
      </div>
    </div>
  );
}
